import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Animate, AnimateKeyframes, AnimateGroup } from 'react-simple-animate';
import Excess from './excess.jsx';
import DatePicker from 'react-datepicker';
import moment from 'moment';

export default class ThisDriversArchivedExcesses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      url: props.url || '/api/v1/portal/drivers/excesses',
      excessAccountId: props.excessAccountId || null,
      excesses: [],
    };
    this.handleExcessesTableRefresh = this.handleExcessesTableRefresh.bind(this);
    this.handleExcessesTableRefresharc = this.handleExcessesTableRefresharc.bind(this);
    this.editModalManage = this.editModalManage.bind(this);
    this.handleCallParentMethod = this.handleCallParentMethod.bind(this);
  }

  componentDidMount() {
    var that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/excesses/'+
      this.state.excessAccountId+'/archived',
      method: 'GET',
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(excessesJson) {
      that.setState({
        excesses: excessesJson,
        isLoading: false
      });
    });
  }
  handleExcessesTableRefresharc(){
    var that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/excesses/'+
      this.state.excessAccountId+'/archived',
      method: 'GET',
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(excessesJson) {
      that.setState({
        excesses: excessesJson,
        isLoading: false
      });
    });
  }
  handleExcessesTableRefresh(){
    var that = this;
    $.ajax({
      url: '/api/v1/portal/drivers/excesses/'+this.state.excessAccountId+'/current',
      method: 'GET',
      data: {api_token: window.api_token},
      cache: false
    })
    .done(function(excessesJson) {
      that.setState({
        excesses: excessesJson,
        isLoading: false
      });
    });
  }
  editModalManage(editId){
    $('#'+editId+'-edit-row').toggleClass('toggle-hide');
  }
  handleCallParentMethod(total, paid_total){
    this.props.handleTotalAmountUpdate(total);
    this.props.handlePaidAmountUpdate(paid_total);
  }

  render() {
    var Excesses = [];
      let editModalManage = this.editModalManage;
      let handleExcessesTableRefresh = this.handleExcessesTableRefresh;
      let handleExcessesTableRefresharc = this.handleExcessesTableRefresharc;
      let handleCallParentMethod = this.handleCallParentMethod;
      if (this.state.excesses.length > 0) {
        this.state.excesses.forEach(function(i,index) {
            Excesses.push(<Excess key={'excess-'+i.id} data={i} 
                handleExcessesTableRefresharc={handleExcessesTableRefresharc}
                editModalManage={editModalManage}
                handleCallParentMethod={handleCallParentMethod}/>);
            Excesses.push(
              <tr id={i.id+"-edit-row"} key={'excess-'+index} className="toggle-hide">
                <td colSpan="7"> 
                  <EditModal data={i} 
                  handleExcessesTableRefresh={handleExcessesTableRefresh}
                  handleExcessesTableRefresharc={handleExcessesTableRefresharc}
                  editModalManage={editModalManage}
                  handleCallParentMethod={handleCallParentMethod} />
                </td>
              </tr>
            );
          });
        }
    return (
      <div>
        <div className="row ">
          <table className="driver-wages-table"> 
                <thead>
                  <tr className="">
                    <th>description</th>
                    <th>ref</th>
                    <th>amounts</th>
                    <th>frequency</th>
                    <th>details</th>
                    <th>Edit</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody>
                {Excesses}
                </tbody>
              </table>
        </div>
      </div>
    );
  }
}
class EditModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      data: props.data || null,
    };
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleDailyDateChange = this.handleDailyDateChange.bind(this);
    this.handleHourlyDateSTimeChange = this.handleHourlyDateSTimeChange.bind(this);
    this.handleHourlyDateETimeChange = this.handleHourlyDateETimeChange.bind(this);
    this.handleDeductionOccurance = this.handleDeductionOccurance.bind(this);
  }
  handleStartDateChange(date) {
    this.state.data.start_date = date;
    this.setState({data: this.state.data});
  }
  handleEndDateChange(date) {
    this.state.data.end_date = date;
    this.setState({data: this.state.data});
  }
  handleDailyDateChange(date) {
    this.state.data.selected_day = date;
    this.setState({data: this.state.data});
  }
  handleHourlyDateSTimeChange(date) {
    this.state.data.selected_starttime = date;
    this.setState({data: this.state.data});
  }
  handleHourlyDateETimeChange(date) {
    this.state.data.selected_endtime = date;
    this.setState({data: this.state.data});
  }
  handleDeductionOccurance(e){
    this.state.data.deduction_occurance =  e.target.value;
    this.setState({data: this.state.data});
  }
  handleDescChange(e){
    this.state.data.description =  e.target.value;
    this.setState({data: this.state.data});
  }
  handleRefChange(e){
    this.state.data.insurance_reference =  e.target.value;
    this.setState({data: this.state.data});
  }
  handleOriginalAmountChange(e){
    this.state.data.original_amount_to_repay =  e.target.value;
    this.setState({data: this.state.data});
  }
  handleAgreedAmountChange(e){
    this.state.data.agreed_deduction_amount =  e.target.value;
    this.setState({data: this.state.data});
  }
  handleEditFormSubmitButtonClick(e){
    e.preventDefault();
    let that = this;
    this.setState({isLoading:true});
    let editData = {
      api_token: window.api_token,
      driver_id: this.state.data.driver_id,
      id:this.state.data.id,
      description: this.state.data.description,
      insurance_reference: this.state.data.insurance_reference,
      original_amount_to_repay: this.state.data.original_amount_to_repay,
      deduction_occurance: this.state.data.deduction_occurance,
      agreed_deduction_amount: this.state.data.agreed_deduction_amount,
      start_date: (this.state.data.start_date != null) ? moment(this.state.data.start_date).format("YYYY-MM-DD") : null,
      end_date: (this.state.data.end_date != null) ? moment(this.state.data.end_date).format("YYYY-MM-DD") : null,
      selected_day: (this.state.data.selected_day != null) ? moment(this.state.data.selected_day).format("YYYY-MM-DD") : null,
      selected_starttime: (this.state.data.selected_starttime) ? moment(this.state.data.selected_starttime).format("YYYY-MM-DD h:mm a") : null,
      selected_endtime: (this.state.data.selected_endtime != null) ? moment(this.state.data.selected_endtime).format("YYYY-MM-DD h:mm a"): null,
    };
    $.ajax({
      type: "POST",
      url: '/api/v1/portal/drivers/excesses/edit-excess',
      data: editData,
      dataType: "text/json",
      complete: function(response) {
        that.setState({isLoading:false});
        if (response.status == 200) {
          $('#infomodallabel').html('Excess');
          $('#infomodal .modal-body').html('Excess has been updated sucessfully..');
          $('#infomodal').modal();
          that.props.handleExcessesTableRefresh();
          that.props.handleExcessesTableRefresharc();
          that.props.editModalManage(that.state.data.id);
          let txt = JSON.parse(response.responseText)
          that.props.handleCallParentMethod(txt.total, txt.total_paid);
        }
        else {
          $('#infomodallabel').html('Error updating excess');
          $('#infomodal .modal-body').html($.parseHTML(
            response.responseText.
            replace(/\"/g, ""))
          );
          $('#infomodal').modal();
        }
      }
    });
    return false;
  }
  render() {
    return (
      
        <fieldset>
          <div className="row">
            <div className="col-md-6 text-right">Description</div>
            <div className="col-md-6 text-left">
              <input
                className="form-control form-control-lg"
                name="description"
                type="text" placeholder="description" 
                value={this.state.data.description}
                onChange={(e)=>this.handleDescChange(e)}/>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 text-right">Reference</div>
            <div className="col-md-6 text-left">
              <input
              className="form-control form-control-lg"
              name="insurance_reference"
              type="text" placeholder="reference"
              value={this.state.data.insurance_reference} 
              onChange={(e)=>this.handleRefChange(e)}/>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 text-right">Amount to Repay:</div>
            <div className="col-md-6 text-left">
              <input
                className="form-control form-control-lg"
                name="original_amount_to_repay"
                type="text" placeholder="&pound; original amount to repay"
                value={this.state.data.original_amount_to_repay}
                onChange={(e)=>this.handleOriginalAmountChange(e)} />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 text-right">@</div>
            <div className="col-md-6 text-left">
              <input type="text" placeholder="&pound;agreed deduction amount"
              name="agreed_deduction_amount" id="agreed_deduction_amount"
              className="form-control"
              value={this.state.data.agreed_deduction_amount}
              onChange={(e)=>this.handleAgreedAmountChange(e)} />
            per <select name="deduction_occurance" value={this.state.data.deduction_occurance} id="deduction_occurance" onChange={this.handleDeductionOccurance}>
              <option value="weekly">Week</option>
              <option value="monthly">Month</option>
              <option value="daily">Day</option>
              <option value="hourly">Hour</option>
            </select><br />
          </div>
        </div>
        { this.state.data.deduction_occurance == 'weekly' ? 
        <div className="weekly">
          <div className="row">
            <div className="col-md-6 text-right">Start Date:</div>
            <div className="col-md-6 text-left">
                <DatePicker todayButton={"Today"} dateFormat="dd-MM-yyyy" onChange={this.handleStartDateChange} 
                selected={(this.state.data.start_date) ? moment(this.state.data.start_date).toDate() : null}/>
          </div>
          </div>
          <div className="row">
            <div className="col-md-6 text-right">End Date:</div>
            <div className="col-md-6 text-left">
                <DatePicker todayButton={"Today"} dateFormat="dd-MM-yyyy" onChange={this.handleEndDateChange} 
                selected={(this.state.data.end_date) ? moment(this.state.data.end_date).toDate() : null }/>
            </div>
          </div>
        </div> : ''}
        { this.state.data.deduction_occurance == 'daily' ? 
        <div className="daily">
          <div className="row">
            <div className="col-md-6 text-right">Select Day:</div>
            <div className="col-md-6 text-left">
                <DatePicker todayButton={"Today"} dateFormat="dd-MM-yyyy" onChange={this.handleDailyDateChange} 
                selected={(this.state.data.selected_day) ? moment(this.state.data.selected_day).toDate()  : null}/>
            </div>
          </div>
        </div> : ''}
        { this.state.data.deduction_occurance == 'hourly' ? 
        <div className="hourly">
          <div className="row">
            <div className="col-md-6 text-right">Select Start Time:</div>
            <div className="col-md-6 text-left">
                <DatePicker todayButton={"Today"} timeInputLabel="Time:" dateFormat="dd-MM-yyyy h:mm aa" showTimeInput onChange={this.handleHourlyDateSTimeChange} 
                selected={(this.state.data.selected_starttime) ?  moment(this.state.data.selected_starttime).toDate() : null}/>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 text-right">Select End Time:</div>
            <div className="col-md-6 text-left">
                <DatePicker todayButton={"Today"} timeInputLabel="Time:" dateFormat="dd-MM-yyyy h:mm aa" showTimeInput onChange={this.handleHourlyDateETimeChange} 
                selected={(this.state.data.selected_endtime) ? moment(this.state.data.selected_endtime).toDate() : null}/>
            </div>
          </div>
        </div> : ''}
        <div className="row">
            <div className="col-md-6 text-right">&nbsp;</div>
            <div className="col-md-6 text-left">
            <button className="btn btn-sm btn-primary" disabled={(this.state.isLoading) ? true : false}
              onClick={(e) => {
                this.handleEditFormSubmitButtonClick(e)
              }}>
              <i className="fa fa-plus"></i> Save Excess</button>
            </div>
            <br/>
        </div>
      </fieldset>
    
    );
  }

}